import { REQUEST, FAILURE, SUCCESS, action, createRequestTypes } from 'redux-config/reduxHelpers';

export const GET_CRM_FINANCES_DEPOSITS = createRequestTypes('GET_CRM_FINANCES_DEPOSITS');
export const getCrmFinancesDeposits = {
  request: ({ search }) => action(GET_CRM_FINANCES_DEPOSITS[REQUEST], { search }),
  success: data => action(GET_CRM_FINANCES_DEPOSITS[SUCCESS], { data }),
  failure: error => action(GET_CRM_FINANCES_DEPOSITS[FAILURE], { error }),
};

export const GET_CRM_FINANCES_WITHDRAWALS = createRequestTypes('GET_CRM_FINANCES_WITHDRAWALS');
export const getCrmFinancesWithdrawals = {
  request: ({ search }) => action(GET_CRM_FINANCES_WITHDRAWALS[REQUEST], { search }),
  success: data => action(GET_CRM_FINANCES_WITHDRAWALS[SUCCESS], { data }),
  failure: error => action(GET_CRM_FINANCES_WITHDRAWALS[FAILURE], { error }),
};

export const GET_CRM_FINANCES_TRANSFERS = createRequestTypes('GET_CRM_FINANCES_TRANSFERS');
export const getCrmFinancesTransfers = {
  request: ({ search }) => action(GET_CRM_FINANCES_TRANSFERS[REQUEST], { search }),
  success: data => action(GET_CRM_FINANCES_TRANSFERS[SUCCESS], { data }),
  failure: error => action(GET_CRM_FINANCES_TRANSFERS[FAILURE], { error }),
};

export const GET_CRM_FINANCES_PAYMENT_SYSTEMS = createRequestTypes('GET_CRM_FINANCES_PAYMENT_SYSTEMS');
export const getCrmFinancesPaymentSystems = {
  request: () => action(GET_CRM_FINANCES_PAYMENT_SYSTEMS[REQUEST]),
  success: data => action(GET_CRM_FINANCES_PAYMENT_SYSTEMS[SUCCESS], { data }),
  failure: error => action(GET_CRM_FINANCES_PAYMENT_SYSTEMS[FAILURE], { error }),
};
